<template lang="html">
    <div class="loanClosureContainer">

        <div class="top-bar">
            <span @click="goBackToAssignPerksPage">
                <i class="left"></i>
            </span>
            <span class="heading_closure">Loan Closure</span>
        </div>

        <div class="main-container">

            <div class="">
                <div class="card">
                    <div class="image">
                        <img src="@/assets/user.svg" class="alignImage">
                    </div>
                    <div class="card-data">
                        <span>
                            <label class="emp-details">Chetan garg</label>
                        </span>
                        <br>
                        <span class="details">
                            <label>12345</label>
                        </span>
                        <br>
                        <span class="details">
                            <label>test@test.com</label>
                        </span>
                    </div>

                    <div class="close-card" v-on:click="$emit('click')">
                        <span> x </span>
                    </div>
                </div>
            </div>

            <div class="margin-top-29">
                <div class="threeColumnGrid">
                    <txt autofocus="autofocus" label="Total Loan Amount" type="number" v-model='formData.totalLoanAmount' name="totalLoanAmount"
                        v-validate="'required'" :classname="errors.has('totalLoanAmount')" :errormsg="errors.first('totalLoanAmount')"
                    />
                    <txt autofocus="autofocus" label="Deducted till date" type="number" v-model='formData.deductedTillDate' name="deductedTillDate"
                        v-validate="'required'" :classname="errors.has('deductedTillDate')" :errormsg="errors.first('deductedTillDate')"
                    />
                    <txt autofocus="autofocus" label="Loan Balance Amount" type="number" v-model='formData.loanBalanceAmount' name="loanBalanceAmount"
                        v-validate="'required'" :classname="errors.has('loanBalanceAmount')" :errormsg="errors.first('loanBalanceAmount')"
                    />
                </div>
            </div>

            <div class="margin-top-20">
                <label class="sub-heading-label">Closure Type</label>
                <div class="customGrid margin-top-13">
                    <tl-radio label="Partial Closure" name="closureType" id="partial_closure" value="partial" @change="(val)=>closureType=val"
                    />
                    <tl-radio label="Full Closure" name="closureType" id="full_closure" value="full" @change="(val)=>closureType=val"
                    />
                </div>

            </div>

            <div class="margin-top-20">
                <txt autofocus="autofocus" label="Closure Amount" type="number" v-model='formData.closureAmount' name="closureAmount" v-validate="'required'"
                    :classname="errors.has('closureAmount')" :errormsg="errors.first('closureAmount')" />
            </div>

            <div class="margin-top-20">
                <label class="sub-heading-label">Mode of Payment</label>
                <div class="customGrid margin-top-13">
                    <tl-radio  label="Outside Payroll" name="paymentMode" id="paymentMode_outside_payroll" value="outside_payroll" @change="(val)=>paymentMode=val"
                    />
                    <tl-radio label="Through Payroll" name="paymentMode" id="paymentMode_through_payroll" value="through_payroll" @change="(val)=>paymentMode=val"
                    />
                </div>
            </div>

            <bottom-action-container>
                <template slot="end">
                    <btn-grp>
                        <btn text="Cancel" type="secondary" @click="goBackToAssignPerksPage" />
                        <btn text="Save" type="primary" @click="save" />
                    </btn-grp>
                </template>
            </bottom-action-container>

            <pop-up-message v-if="showSuccessMsg" message="Loan closure details have been updated." btnText="Ok" @back="()=>showSuccessMsg=false"
            />

        </div>

    </div>


</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "loanCalculation",
  computed: {
    ...mapState({}),
    ...mapGetters({
      orgid: "onboard/organization/orgid"
    })
  },
  data() {
    return {
      formData: {
        totalLoanAmount: "",
        deductedTillDate: "",
        loanBalanceAmount: "",
        closureAmount: ""
      },
      showSuccessMsg: false,
      closureType: "partial",
      paymentMode: "outside_payroll"
    };
  },
  mounted() {},

  methods: {
    ...mapActions({}),

    goBackToAssignPerksPage() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/assignperk`
      });
    },

    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction().then(() => {
            this.showSuccessMsg = true;
          });
        }else{
            this.showSuccessMsg = false;
        }
      });
    },

    async performAction() {

        
    }
  }
};
</script>

<style lang="scss" scoped>
.margin-top-29 {
  margin-top: 2.9%;
}

.margin-top-20 {
  margin-top: 20px;
}

.margin-top-13 {
  margin-top: 13px;
}

.loanClosureContainer {
  width: 100%;
  height: 100%;
  .inner-container {
    padding: 0px 0px 0px 1%;
  }
  .top-bar {
    height: auto;
    padding: 20px;
    background-color: #34c0be;
    display: flex;
  }
}

.heading_closure {
  font-family: Montserrat;
  font-size: 24px;
  font-weight: bold;
  color: #ffffff;
  height: auto;
}

.left {
  border: solid white;
  border-width: 0 2px 2px 0;
  padding: 5px;
  transform: rotate(135deg);
  -webkit-transform: rotate(135deg);
  margin-top: 9px;
  margin-right: 15px;
  cursor: pointer;
}

.label{
      margin-right: 15px !important;
}

.threeColumnGrid {
  grid-template-columns: 24% 24% 24%;
}

.sub-heading-label {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: normal;
  color: #646464;
}

.card {
  display: flex;
  width: 23.5%;
  margin-right: 12px;
  height: 102px;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
}

.image {
  padding-top: 24px;
  padding-left: 15px;
  .alignImage {
    width: 50px;
    height: 50px;
    padding: 0px 0 0 0px;
  }
}

.card-data {
  padding: 22px 0 0 10px;
}

.emp-details {
  color: #535353;
  font-size: 16px;
  font-weight: 500;
}

.details {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: normal;
  color: #979797;
}

.close-card {
  cursor: pointer;
  color: #6e6e6e;
  width: 12px;
  height: 12px;
  padding: 2px 0 0 105px;
  font-weight: 600;
}

.Rectangle {
  width: 338px;
  height: 102px;
  opacity: 0.8;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
}

.customGrid {
    display: grid;
    grid-template-columns: 17% 17% auto;
    grid-row-gap: 15px;
    grid-column-gap: 20px;
}
</style>